import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { PipesModule } from '../../../pipes';
import { CheckboxModule } from '../../checkbox/checkbox.module';
import { GenericLinkModule } from '../../generic-link';
import { ReactiveFormCheckboxComponent } from './reactive-form-checkbox.component';

@NgModule({
  declarations: [ReactiveFormCheckboxComponent],
  imports: [CommonModule, ReactiveFormsModule, PipesModule, CheckboxModule, GenericLinkModule, NzIconModule],
  exports: [ReactiveFormCheckboxComponent],
})
export class ReactiveFormCheckboxModule {}
